module.exports = __webpack_public_path__ + "static/media/va.9d57ef03.svg";